import type { MutationTree } from "vuex";
import type { WebSocketState, WebSocketResponse } from "@/types";

export const LOAD_NEW_MESSAGE = "LOAD_NEW_MESSAGE";
export const LOAD_WS = "LOAD_WS";
export const DISCONNECT_WS = "DISCONNECT_WS";
export const SEND_IMPORT_REQUEST = "SEND_IMPORT_REQUEST";
export const INIT_MANUAL_DATA = "INIT_MANUAL_DATA";
export const ACTIV_MANUAL_DATA = "ACTIV_MANUAL_DATA";
export const VALIDATE_MANUAL_DATA = "VALIDATE_MANUAL_DATA";

export const mutations: MutationTree<WebSocketState> = {
  [LOAD_NEW_MESSAGE](state: WebSocketState, data: WebSocketResponse) {
    state.wsData = data;
  },
  [LOAD_WS](state: WebSocketState, ws: WebSocket) {
    state.ws = ws;
  },
  [VALIDATE_MANUAL_DATA](state: WebSocketState, data: WebSocketResponse) {
    state.wsValidateData = data;
  },
  [INIT_MANUAL_DATA](state: WebSocketState) {
    state.uploadManualData = false;
  },
  [ACTIV_MANUAL_DATA](state: WebSocketState) {
    state.uploadManualData = true;
  },
  [DISCONNECT_WS](state: WebSocketState) {
    state.ws && state.ws.close();
    state.ws = null;
    state.wsData = null;
  },
  [SEND_IMPORT_REQUEST](state: WebSocketState, data: any) {
    const ws = state.ws;
    console.log(ws, data);
    ws?.send(JSON.stringify(data));
  },
};
